<template>
  <section class="component-container" v-if="isLoaded && isVisible">
    <div class="band-title-wrap">
      <h1 class="component-title" tabindex="0" v-band-title>{{sectionInfoTitle}}</h1>
      <span v-if="isSearchView && hasCount" class="search-result-number" :aria-label="'검색 결과 ' + sectionInfo.count + '건'">{{sectionInfo.count}}</span>
    </div>
    <div class="cell-container">
      <ul class="cell-list scroll cell-mytype">
        <li v-for="(cell, index) in cellList" :key="`keyword_${index}`">
          <a href="#" @click.prevent="goDetail(cell, index)">
            <div class="cell-info">
              <div class="cell-title-wrap" v-title-list="{'titleList': cellTitleList(cell)}"></div>
            </div>
          </a>
        </li>
      </ul>
      <view-more v-if="hasViewMore" :route-to-list-fn="routeToList" :view-more-title="sectionInfo.title"></view-more>
    </div>
  </section>
</template>

<script>
import { get } from 'lodash'
import { bandTitle, titleList } from '@/common/directives'
import { mapActions } from 'vuex'
import { FETCH_BAND_INFO } from '@/store/types/actions.type'
import EventModelClass from '@/common/model/EventModelClass'
import { hasViewMore, sectionInfoTitle, selectCell, viewMoreTitle } from '@/common/util/common'
import ViewMore from '@/components/section/template/viewmore/ViewMore'
import { parseUrl, stringify } from 'query-string'
import { PATH_NAME_SEARCH, PATH_NAME_SEARCH_TAG } from '@/common/router.const'
import { sendEventLogSearchCategoryCell } from '@/common/util/log.v2.send'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'

export default {
  name: 'TemplateTwoLineText',
  props: {
    sectionInfo: {
      type: Object
    }
  },
  components: {
    ViewMore
  },
  directives: {
    bandTitle,
    titleList
  },
  data () {
    return {
      cellList: [],
      genTime: '',
      isLoaded: false,
      isVisible: true,
      isSearchView: false
    }
  },
  computed: {
    sectionInfoTitle () {
      return sectionInfoTitle(this.sectionInfo)
    },
    hasViewMore () {
      return hasViewMore(this.sectionInfo)
    },
    viewMoreTitle () {
      return viewMoreTitle(this.sectionInfo)
    },
    hasCount () {
      return get(this.sectionInfo, 'count', '0') !== '0'
    }
  },
  methods: {
    ...mapActions({ fetchBandData: FETCH_BAND_INFO }),
    setData () {
      this.fetchBandData(
        { eventModel: new EventModelClass(get(this.sectionInfo, 'contentEvent', {})),
          force: get(this.sectionInfo, 'forceRefresh', false) })
        .then((response) => {
          if (this.genTime !== get(response, 'genTime', '') || get(response, 'genTime', '') === null) {
            this.cellList = get(response, 'cellList', [])
            if (this.cellList.length === 0) this.isVisible = false
          }
          this.isLoaded = true
        })
    },
    itemTitle (cell) {
      return get(cell, 'title_list.0.text', '')
    },
    goDetail (cell, index) {
      if (LOG_SEND_LIST.includes(this.$route.name)) sendEventLogSearchCategoryCell({ cellInfo: cell, index: index })
      selectCell(cell)
    },
    routeToList () {
      const { url, query } = parseUrl(get(this.sectionInfo, 'viewMoreEvent.url', ''))
      let newUrl = url
      newUrl = newUrl.replace('https://', '')
      newUrl = newUrl.replace('http://', '')
      newUrl = newUrl.replace('m.pooq.co.kr', '')
      newUrl = newUrl.replace('www.pooq.co.kr', '')
      newUrl = newUrl.replace('www.wavve.com', '')
      newUrl = newUrl.replace('m.wavve.com', '')
      newUrl = newUrl.replace('.html', '')
      this.$router.push(newUrl + '?' + stringify(query))
    },
    cellTitleList (cell) {
      return get(cell, 'title_list', [])
    }
  },
  created () {
    const routeName = get(this.$route, 'name', '')
    this.isSearchView = routeName.indexOf(PATH_NAME_SEARCH_TAG) > -1 || routeName === PATH_NAME_SEARCH
    this.setData()
  }
}
</script>
